// ============================================================
// 出口实体
// ============================================================
import * as THREE from 'three';
import { EXIT_HALF_WIDTH, EXIT_HEIGHT } from '../config';

export class Exit {
  readonly group = new THREE.Group();
  readonly position: THREE.Vector3;
  private glowLight: THREE.PointLight;

  constructor(worldX: number, worldZ: number) {
    this.position = new THREE.Vector3(worldX, EXIT_HEIGHT / 2, worldZ);

    // 门框 - 环形
    const frameMaterial = new THREE.MeshStandardMaterial({
      color: '#ffaa33',
      roughness: 0.2,
      metalness: 0.8,
      emissive: '#331100',
      emissiveIntensity: 0.7,
    });

    // 左侧柱
    const pillarGeo = new THREE.BoxGeometry(0.2, EXIT_HEIGHT, 0.2);
    const leftPillar = new THREE.Mesh(pillarGeo, frameMaterial);
    leftPillar.position.set(-EXIT_HALF_WIDTH, EXIT_HEIGHT / 2, 0);
    this.group.add(leftPillar);

    const rightPillar = new THREE.Mesh(pillarGeo, frameMaterial);
    rightPillar.position.set(EXIT_HALF_WIDTH, EXIT_HEIGHT / 2, 0);
    this.group.add(rightPillar);

    // 顶部横梁
    const topGeo = new THREE.BoxGeometry(EXIT_HALF_WIDTH * 2 + 0.2, 0.2, 0.2);
    const topBeam = new THREE.Mesh(topGeo, frameMaterial);
    topBeam.position.set(0, EXIT_HEIGHT, 0);
    this.group.add(topBeam);

    // 发光粒子环
    const ringGeo = new THREE.TorusGeometry(EXIT_HALF_WIDTH * 0.7, 0.08, 8, 24);
    const ringMat = new THREE.MeshBasicMaterial({ color: '#ffcc44' });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.position.set(0, EXIT_HEIGHT * 0.75, 0);
    this.group.add(ring);

    // 点光源
    this.glowLight = new THREE.PointLight('#ffaa33', 3, 10);
    this.glowLight.position.set(0, EXIT_HEIGHT / 2, 0);
    this.group.add(this.glowLight);

    this.group.position.set(worldX, 0, worldZ);
  }

  update(_delta: number, elapsed: number): void {
    // 光晕脉冲
    const pulse = 1 + Math.sin(elapsed * 2.5) * 0.15;
    this.glowLight.intensity = 3 * pulse;
  }

  dispose(): void {
    this.glowLight.dispose();
  }
}
